import * as React from 'react';

const Launchpad = props => {
  const { className } = props;
  const launchpad = 'assets/launchpad.png';
  return <img className={className} src={launchpad} />;
};

export default Launchpad;
